import { logg } from '@/util/logg';

const ExistingGameList = ({ gameList, navToExistingGame }) => {
	logg('ExistingGameList', gameList);

	return (
		<>
			{gameList &&
				gameList.length > 0 &&
				gameList.map((playerGameRel: any) => {
					return (
						<div key={playerGameRel.game_id}>
							{playerGameRel.game_id}
							<button
								onClick={(e) =>
									navToExistingGame(e, playerGameRel.game_id)
								}
							>
								Rejoin Game
							</button>
						</div>
					);
				})}
		</>
	);
};

export default ExistingGameList;
